'use client'

import React from 'react'
import { useParams } from 'next/navigation'
import { Loader2 } from 'lucide-react'
import { getReceipt } from '@/lib/actions/order/get-reciept'
import { getPrinterType } from '@/lib/actions/register/get-printer-type'
import { useModals, useSearchParams } from '@/lib/hooks'

import { Dialog, DialogContent } from '@/components/ui'
import { PrintReceipt } from '@/components/molecules'

interface PrintReceiptModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const PrintReceiptModal = ({ open }: PrintReceiptModalProps) => {
  const { closeModal } = useModals()
  const [isPending, startTransition] = React.useTransition()
  const [printerType, setPrinterType] = React.useState<string | null>('thermal')
  const [receipt, setReceipt] = React.useState<any>(null)
  const { orderId: orderIdParam } = useSearchParams()
  const { order_id } = useParams()

  const orderId = orderIdParam ?? order_id

  React.useEffect(() => {
    if (!orderId) return

    startTransition(async () => {
      const getPrinter = await getPrinterType()
      const receipt = await getReceipt(orderId)
      setPrinterType(getPrinter?.printerType ?? null)
      setReceipt(receipt)
    })
  }, [orderId])

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal('PRINT_RECEIPT')
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('PRINT_RECEIPT')}
        size="lg"
        className="min-h-[410px] gap-8"
        closeButtonClassName="hidden"
      >
        {isPending && (
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="animate-spin text-gray-300" />
          </div>
        )}

        {orderId && !isPending && (
          <PrintReceipt printerType={printerType} receipt={receipt} />
        )}
      </DialogContent>
    </Dialog>
  )
}
